import { retry } from '@reduxjs/toolkit/query';
import { userTimezone } from '@/const';
import { baseQueryWithStatusCheck } from '../baseQueryWithStatusCheck';
import type { SearchParams } from './dataLayersApi.types';

// =======================
// Query Configuration
// =======================

export const baseQuery = retry(baseQueryWithStatusCheck, {
  maxRetries: 1,
});

// =======================
// Utility Functions
// =======================

/**
 * Converts SearchParams to URLSearchParams
 * Handles arrays by appending multiple values with the same key
 * Automatically appends user timezone
 */
export const getSearchParams = (params: SearchParams): URLSearchParams => {
  const searchParams = new URLSearchParams();
  (Object.entries(params) as [keyof SearchParams, any][]).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      // Handle arrays (e.g., snapshot_timestamp can be string[], asset_type can be string[])
      if (Array.isArray(value)) {
        // For arrays, append each value with the same key
        value.forEach((v) => searchParams.append(key, String(v)));
      } else {
        searchParams.append(key, String(value));
      }
    }
  });
  searchParams.append('timezone', userTimezone);
  return searchParams;
};